import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { useBreadcrumbs } from "./useBreadcrumbs";

const Breadcrumbs = () => {
  const breadcrumbs = useBreadcrumbs();
  
  // Don't show breadcrumbs if there are no breadcrumbs or only one item
  if (breadcrumbs.length === 0 || breadcrumbs.length === 1) {
    return null;
  }
  
  return (
    <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-4 px-1 mb-5 mt-2 pt-2">
      {breadcrumbs.map((breadcrumb, index) => (
        <React.Fragment key={breadcrumb.path}>
          {index > 0 && (
            <ChevronRight className="w-4 h-4 text-gray-400" />
          )}
          {breadcrumb.isLast ? (
            <span className="text-gray-900 font-medium flex items-center">
              {breadcrumb.icon === 'home' && <Home className="w-4 h-4 mr-1" />}
              {breadcrumb.name}
            </span>
          ) : (
            <Link
              to={breadcrumb.path}
              className="text-gray-600 hover:text-gray-900 transition-colors flex items-center"
            >
              {breadcrumb.icon === 'home' && <Home className="w-4 h-4 mr-1" />}
              {breadcrumb.name}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumbs; 